export default function MySQL_UNIQUE() {
  return (
    <div>
      <h2>MySQL_UNIQUE</h2>    </div>
  );
}